/**
 * MemberSelector — Searchable dropdown for selecting a battalion member.
 * Sprint 9, SDD §7.2 — Used by officers to select a member for entry submission.
 * FR-OFFICER-01
 */

export interface MemberOption {
  id: number;
  display_name: string;
  email: string;
  battalion_id: number | null;
}

interface MemberSelectorProps {
  members: MemberOption[];
  selected: number | null;
  onChange: (memberId: number | null) => void;
  loading?: boolean;
}

export default function MemberSelector({ members, selected, onChange, loading = false }: MemberSelectorProps) {
  if (loading) {
    return (
      <div className="px-3 py-3 bg-surface-raised rounded-lg border border-edge-default text-content-tertiary text-sm">
        Loading members...
      </div>
    );
  }

  return (
    <div className="w-full">
      <select
        value={selected ?? ''}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val ? parseInt(val, 10) : null);
        }}
        className={`w-full px-3 py-3 bg-surface-raised rounded-lg text-sm cursor-pointer appearance-none bg-[url("data:image/svg+xml,%3Csvg_xmlns='http://www.w3.org/2000/svg'_width='12'_height='12'_viewBox='0_0_12_12'%3E%3Cpath_fill='%23999999'_d='M6_8L1_3h10z'/%3E%3C/svg%3E")] bg-no-repeat bg-[right_14px_center] pr-9 ${
          selected
            ? 'border-2 border-action-primary text-content-primary'
            : 'border border-edge-default text-content-tertiary'
        }`}
      >
        <option value="">Select a member...</option>
        {members.map((member) => (
          <option key={member.id} value={member.id}>
            {member.display_name}
          </option>
        ))}
      </select>
    </div>
  );
}
